var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "card", attrs: { "max-width": "700" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("layout-history")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("common.close"),
                  expression: "$ct('common.close')",
                },
              ],
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.count == 0
        ? _c(
            "w-row",
            { staticClass: "content", attrs: { center: "" } },
            [
              _c("w-col", { attrs: { center: "" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("common.empty-list")) + " "),
              ]),
            ],
            1
          )
        : _c(
            "w-scroll-view",
            {
              attrs: { tag: "w-list" },
              nativeOn: {
                scroll: function ($event) {
                  return _vm.onScroll($event)
                },
              },
            },
            _vm._l(_vm.items, function (item) {
              return _c(
                "w-list-item",
                { key: item.ID },
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.getItemName(item))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("open-settings"),
                              expression: "$ct('open-settings')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.loadSettings(item)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "download" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }